import { BundleMessage } from 'components/Dialogue';
import { MessageExtendComplex } from '../MessageExtend/MessageExtendComplex';
import { BaseMsgProps } from './types';
import { memo } from 'react';

export const BundleMessageMsg = memo((props: BaseMsgProps) => {
  return <MessageExtendComplex {...props} content={<BundleMessage {...props} />} />;
});
